import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import CommerceOnly from '/src/_includes/commerce-only.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <CommerceOnly mdxType="CommerceOnly" />
    <h1 {...{
      "id": "closenegotiablequotes-mutation"
    }}>{`closeNegotiableQuotes mutation`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`closeNegotiableQuotes`}</inlineCode>{` mutation closes an active negotiable quote. Once a quote is closed, it cannot be re-opened. Closed negotiable quotes can be viewed by the merchant and company users.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "../unions/index.md"
      }}><inlineCode parentName="a">{`CloseNegotiableQuoteOperationResult`}</inlineCode>{` union`}</a>{` is an output object that provides details about the result of a request to close a negotiable quote. To return these details, specify fragments on the `}<inlineCode parentName="p">{`CloseNegotiableQuoteOperationFailure`}</inlineCode>{` and `}<inlineCode parentName="p">{`NegotiableQuoteUidOperationSuccess`}</inlineCode>{` objects. Specify the `}<inlineCode parentName="p">{`__typename`}</inlineCode>{` attribute to distinguish the object types in the response.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`CloseNegotiableQuoteError`}</inlineCode>{` union type contains one or more of the following data types, all of which implement `}<inlineCode parentName="p">{`ErrorInterface`}</inlineCode>{`.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`InternalError`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`NegotiableQuoteInvalidStateError`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`NoSuchEntityUidError`}</inlineCode></li>
    </ul>
    <p>{`This mutation requires a valid `}<a parentName="p" {...{
        "href": "../../../customer/mutations/generate-token.md"
      }}>{`customer authentication token`}</a>{`.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`    closeNegotiableQuotes(
        input: CloseNegotiableQuotesInput!
    ): CloseNegotiableQuotesOutput
`}</code></pre>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#mutation-closeNegotiableQuotes"
      }}><inlineCode parentName="a">{`closeNegotiableQuotes`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this mutation.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following example contains an invalid `}<inlineCode parentName="p">{`quote_uids`}</inlineCode>{` value, causing a FAILURE status.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  closeNegotiableQuotes(
    input: {
      quote_uids: ["xyz"]
    }
  ) {
    result_status,
    operation_results {
      ...on NegotiableQuoteUidOperationSuccess{
        __typename
        quote_uid
      }
      ...on CloseNegotiableQuoteOperationFailure{
        __typename
        quote_uid
        errors {
          __typename
          ...on ErrorInterface{
            message
          }
          ...on NoSuchEntityUidError{
            uid
          }
          ...on NegotiableQuoteInvalidStateError {
            message
          }
        }
      }
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "closeNegotiableQuotes": {
      "result_status": "FAILURE",
      "operation_results": [
        {
          "__typename": "CloseNegotiableQuoteOperationFailure",
          "quote_uid": "xyz",
          "errors": [
            {
              "__typename": "NoSuchEntityUidError",
              "message": "Could not find a quote with the specified UID.",
              "uid": "xyz"
            }
          ]
        }
      ]
    }
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      